<template>
  <mv-page>
    <mv-default-row>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card flat>
            <v-card-text>
              <h2>Пополнить баланс карты доступа Вы можете в офисах и терминалах оплаты следующих банков:</h2>
              <banks></banks>
              <br />

              <div class="bs-callout bs-callout-danger col-xs-12">
                  <strong>Важно!</strong>
                  <p>Если Ваш ребенок потерял карту, то при входе в школу и выходе из нее, ребенка пропускает охранник, сервис рассылки СМС-сообщений для родителей не доступен, при этом безналичный расчет в столовой возможен только по комплексному меню.</p>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card flat>
            <v-card-text>
              <h2>Читайте также:</h2>
              <h3><a href="/#/">Часто задаваемые вопросы</a></h3>
              <h3 v-if="false"><a href="/#/sms">Как управлять сервисом с помощью смс-команд</a></h3>
              <h3><a href="/#/additionalservices">Дополнительные платные услуги, оказываемые МБУ «ЦДС ГПТ»</a></h3>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </mv-default-row>
  </mv-page>
</template>
<script>
import Banks from '@/components/Banks.vue'
export default {
  components: {
    Banks
  }
}
</script>

<style lang="css">
</style>
